import { lazy } from 'react';

// project imports
import AuthGuard from 'utils/route-guard/AuthGuard';
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';

const NewDepartamentosUser = Loadable(lazy(() => import('views/user/ActivosView/DepartamentosView/NewDepartamentosView')));

const ListDepartamentosUser = Loadable(lazy(() => import('views/user/ActivosView/DepartamentosView/ListDepartamentosView')));

const NewGruposActivosFijosUser = Loadable(lazy(() => import('views/user/ActivosView/GruposActivosFijosView/NewGruposActivosFijosView')));

const ListGruposActivosFijosUser = Loadable(lazy(() => import('views/user/ActivosView/GruposActivosFijosView/ListGruposActivosFijosView')));

const ViewActivosFijosUser = Loadable(lazy(() => import('views/user/ActivosView/ActivosFijosView')));

const ActivosRoutes = {
    path: '/',
    element: (
        <AuthGuard>
            <MainLayout />
        </AuthGuard>
    ),
    children: [
        {
            path: '/user/new-departamentos/:id_departamentos',
            element: <NewDepartamentosUser />
        },        
        {
            path: '/user/list-departamentos-view',
            element: <ListDepartamentosUser />
        },        
        {
            path: '/user/new-grupos-activos-fijos/:id_grupos_activos_fijos',
            element: <NewGruposActivosFijosUser />
        },        
        {
            path: '/user/list-grupos-activos-fijos-view',
            element: <ListGruposActivosFijosUser />
        },        
        {
            path: '/user/activos-fijos-view',
            element: <ViewActivosFijosUser />
        },        
    ]
};

export default ActivosRoutes;